import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IUserNotification } from '@shared/interfaces/user-notifications.interface';
import { PaginatorResult } from '@shared/interfaces/paginator_interface';

@Injectable({
	providedIn: 'root'
})
export class UserNotificationsService {
	private http = inject(HttpClient);
	private url = environment.API_DOMAIN + environment.SERVICES.USER_NOTIFICATIONS;
	private notificationReadSource = new Subject<void>();
	public notificationRead$ = this.notificationReadSource.asObservable();

	/**
	 * Obtiene las notificaciones del usuario actual con paginación
	 * @param page Número de página (por defecto 1)
	 * @param pageSize Tamaño de página (por defecto 10)
	 * @returns Observable con las notificaciones paginadas
	 */
	public getUserNotifications(page: number = 1, pageSize: number = 10): Observable<PaginatorResult<IUserNotification>> {
		const params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString());

		return this.http.get<PaginatorResult<IUserNotification>>(this.url, { params });
	}

	/**
	 * Marca una notificación como leída por ID
	 * @param notificationId ID de la notificación a marcar como leída
	 * @returns Observable<void>
	 */
	public markAsRead(notificationId: number): Observable<void> {
		return this.http.put<void>(`${this.url}/read`, { notificationId }).pipe(
			tap(() => {
				this.notificationReadSource.next();
			})
		);
	}

	/**
	 * Marca todas las notificaciones no leídas del usuario como leídas
	 * @returns Observable<void>
	 */
	public markAllAsRead(): Observable<void> {
		return this.http.put<void>(`${this.url}/read-all`, {}).pipe(
			tap(() => {
				this.notificationReadSource.next();
			})
		);
	}
}
